.chatEmptyState {
  padding-top: 12px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.chatEmptyStateTitle {
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  display: flex;
  align-items: flex-end;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 0px;
}

.chatEmptyStateSubtitle {
  margin-top: 8px;
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  display: flex;
  align-items: flex-end;
  text-align: center;
  letter-spacing: -0.01em;
  color: #616161;
}

.chatIcon {
  height: 50px;
}

.loadingContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.loadingIcon {
  border: 8px solid #f3f3f3;
  /* Light grey */
  border-top: 8px solid #3498db;
  /* Blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
